import { render, staticRenderFns } from "./ConfigurarCertificadoInter.vue?vue&type=template&id=1b275f70"
import script from "./ConfigurarCertificadoInter.vue?vue&type=script&lang=ts"
export * from "./ConfigurarCertificadoInter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports